<template>
  <div class="content" v-if="dataReady">
    <div class="row text-left">
      <!--div class="col-md-12">
        <p class="text-black-50">
          Новый клиент
          <i v-on:click="addNewOne" class="tim-icons icon-single-02"></i>
        </p>
      </div-->
    </div>
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const clientName = {header: "Ф.И.О.", name: "client.name", show: true, sort: true, direction: false, contains: ""};
const clientLastCallDate = {header: "Дата звонка", name: "date", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true};
const clientProjectCallDate = {header: "Плановая дата звонка", name: "projectDate", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true};
const clientNextCallDate = {header: "Дата следующего звонка", name: "nextDate", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true};
const callsExecutor = {header: "Исполнитель", name: "executorData.name", show: false, contains: ""};

export default{
  data() {
    return {
      type: "call",
      content: [clientName, clientProjectCallDate, clientLastCallDate, clientNextCallDate, callsExecutor],
      newOne: null,
      dataReady: false
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', id: 0, contact:{}};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  },
  async mounted() {
    this.dataReady = true;
  }
}
</script>
<style>
</style>
